import { Control } from "react-hook-form"

export type FormValues = {
    fechaReserva: Date[]
    codigoReserva?: string
    origenReserva: string
    tipoDeHabitacion: { id: string; nombre: string }
    tarifas: string[]
    tarifasAdicionales: string[]
    descuentoId?: string
    descuento?: number
    cantidadPersonasExtra?: number
    cantidadPersonas: number
    costoPersonaExtra?: number
    experiencias?: string[]
    reservaIdSaved?: string
    folioSaved?: number
    nombreHuespedSaved?: string
    telefonoHuespedSaved?: string
    emailHuespedSaved?: string
    experienciasSaved?: string[]
    totalSaved?: number
    pagosSaved?: string[]
    comentarioSaved?: string
    habitacionId: string
}

export const defaultValues: FormValues = {
    fechaReserva: [],
    origenReserva: "",
    codigoReserva: "",
    tipoDeHabitacion: { id: "", nombre: "" },
    tarifas: [],
    tarifasAdicionales: [],
    descuentoId: "",
    descuento: 0,
    cantidadPersonasExtra: 0,
    cantidadPersonas: 0,
    experiencias: [],
    reservaIdSaved: "",
    folioSaved: 0,
    nombreHuespedSaved: "",
    telefonoHuespedSaved: "",
    emailHuespedSaved: "",
    experienciasSaved: [],
    pagosSaved: [],
    comentarioSaved: "",
    habitacionId: "",
}

export type FormItemProps = {
    control: Control<FormValues, any>
}

export interface LimiteReservaModal {
    visible: boolean
    date: string
}
